module.exports = __webpack_public_path__ + "img/lg_ring_r_o_null_null@3x.54abd5b1.png";